<template>
  <v-select
    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    :options="processedOptions"
    :clearable="clearable"
    :disabled="readonly"
    :loading="loading"
    :value="value"
    :label="selectionLabel"
    :reduce="(item) => (reduce ? item[selectionKey] : item)"
    @input="input"
    :placeholder="placeholder ? $t(placeholder) : null"
  >
    <template #spinner="{ loading }">
      <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
    </template>
    <template #option="item">
      <span>{{ isTranslateLabelValue ? $t(item[selectionLabel]) : item[selectionLabel] }}</span>
    </template>
    <template #selected-option="item">
      <span>{{ isTranslateLabelValue ? $t(item[selectionLabel]) : item[selectionLabel] }}</span>
    </template>
    <template #no-options>
      {{ $t("selection.noOption") }}
    </template>
  </v-select>
</template>

<script>
import vSelect from 'vue-select'
import { BSpinner } from 'bootstrap-vue'

export default {
  components: {
    vSelect,
    BSpinner,
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    name: {},
    disabled: {},
    readonly: {},
    value: {},
    loading: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default() {
        return []
      },
    },
    reduce: {
      type: Boolean,
      default: false,
    },
    selectionKey: {
      type: String,
      default: 'id',
    },
    selectionLabel: {
      type: String,
      default: 'name',
    },
    isTranslateLabelValue: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      option: [],
      processedOptions: [],
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale.split('-')[0]
    },
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.processedOptions = this.options.map(item => {
          const label = Object.keys(item?.[this.selectionLabel]).length > 0 ? (item?.[this.selectionLabel]?.[this.locale] || item?.[this.selectionLabel]?.en || item?.[this.selectionLabel]?.zh || item?.[this.selectionLabel]?.km || item?.[this.selectionLabel]?.vi || item?.[this.selectionLabel]) : item?.[this.selectionLabel]
          return {
          ...item,
          [this.selectionLabel]: label,
        }
        })
      },
      immediate: true,
    },
  },
  methods: {
    input(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
